export default __webpack_public_path__ + "static/media/748.fbc98983.gif";